import { useEffect } from 'react'
import { UserInfo } from '../../auth/Auth.context'
import { Can } from '../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { SubModulePerms } from '../../refactory/modules/access-control/domain/module'

export const BEAMER_BUTTON_ID = 'beamer-button'

interface UseBeamerProps {
  userInfo: UserInfo
}

export const useBeamer = ({ userInfo }: UseBeamerProps) => {
  useEffect(() => {
    if (userInfo && Can([SubModulePerms.GEN_NEWS_SEE])) {
      const script = document.createElement('script')
      script.src = 'https://app.getbeamer.com/js/beamer-embed.js'
      script.async = true
      ;(window as any).beamer_config = {
        product_id: import.meta.env.VITE_BEAMER_ID,
        selector: BEAMER_BUTTON_ID,
        left: 0,
        user_email: userInfo.user.email,
        user_firstname: userInfo.user.firstName,
        user_lastname: userInfo.user.lastName,
        client_number: userInfo.client.clientNumber,
        cluster: userInfo.client.cluster,
        environment: import.meta.env.VITE_ENVIRONMENT,
        datasource: 'CONTROL_TOWER'
      }
      const append = () => document.body.appendChild(script)
      const useIdleCallback = typeof window.requestIdleCallback === 'function'
      const handle = useIdleCallback
        ? window.requestIdleCallback(append, { timeout: 3000 })
        : window.setTimeout(append, 1500)
      return () => {
        if (useIdleCallback) window.cancelIdleCallback(handle)
        else window.clearTimeout(handle)
        if (script.parentNode) script.parentNode.removeChild(script)
      }
    }
  }, [userInfo])
}
